__turbopack_context__.v({
  "background": "styles-module__R6_LZq__background",
  "price": "styles-module__R6_LZq__price",
  "tileLayout": "styles-module__R6_LZq__tileLayout",
  "tileWrapper": "styles-module__R6_LZq__tileWrapper",
  "title": "styles-module__R6_LZq__title",
  "titleWrapper": "styles-module__R6_LZq__titleWrapper",
});
